<template>
    <div>
        <div
            style="position: -webkit-sticky; position: sticky; top: 48px; background-color:white; z-index:1;"
        >
            <v-container class="pa-0" fluid>
                <v-row no-gutters align="center">
                    <v-col cols="6" md="4" order="1">
                        <v-text-field
                            class="mr-5"
                            v-model.trim="searchQuery"
                            label="Szukaj"
                            prepend-inner-icon="mdi-magnify"
                            maxlength="100"
                            clearable
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4" order="3" order-md="2">
                        <v-select
                            :loading="systemIndexing"
                            v-model="systemId"
                            :items="systems"
                            item-text="SystemName"
                            item-value="SystemID"
                            label="W systemach"
                            :disabled="!systems.length"
                            clearable
                        ></v-select>
                    </v-col>
                    <v-col cols="6" md="4" order="2" order-md="3" class="text-right">
                        <span class="body-2 text--secondary d-none d-sm-inline">{{ from }}-{{ to }} z {{ total }}</span>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on" :disabled="isPageFirst" @click="prevPage">
                                    <v-icon>mdi-chevron-left</v-icon>
                                </v-btn>
                            </template>
                            <span>Poprzednia strona</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on" :disabled="isPageLast" @click="nextPage">
                                    <v-icon>mdi-chevron-right</v-icon>
                                </v-btn>
                            </template>
                            <span>Następna strona</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-container>
            <hr class="mb-1">
        </div>

        <loading-message v-if="blockIndexing" :message="loadingMessage" class="my-5"></loading-message>
        <v-simple-table v-else-if="blocks.length" fixed-header :height="tableHeight" style="table-layout: auto">
            <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-center">Dostęp B2B</th>
                        <th>Bryła</th>
                        <th>Nazwa</th>
                        <th class="text-center">Opis</th>
                        <th class="text-center">Wymiary</th>
                        <th class="text-center">Instrukcja</th>
                        <th class="text-center">Wideo</th>
                        <th class="text-center">WWW</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                <tr
                    v-for="block in blocks"
                    :key="block.BlockID"
                >
                    <td class="text-center text-no-wrap">
                        <block-visibility-switch :block="block"></block-visibility-switch>
                    </td>
                    <th class="text-no-wrap" style="cursor: pointer" @click="showBlockEditDialog(block)">
                        <span class="font-weight-regular">{{ block.System.SystemName }}</span> / {{ block.BlockName }}
                        <br>
                        <div class="font-weight-regular text-caption text--secondary">
                            {{ block.UnitType.UnitTypeName }}
                        </div>
                    </th>
                    <td class="text-no-wrap">{{ block.CommercialName }}</td>
                    <td class="text-center text-no-wrap" style="width: 100%;">
                        {{
                            block.CommercialDescriptionRaw
                                ? block.CommercialDescriptionRaw.length > 100
                                    ? `${block.CommercialDescriptionRaw.slice(0, 99)}…`
                                    : block.CommercialDescriptionRaw
                                : '-'
                        }}
                    </td>
                    <td class="text-center text-no-wrap">{{ block.Length || 0 }} x {{ block.Width || 0 }} x {{ block.Height || 0 }}</td>
                    <td class="text-center text-no-wrap">
                        <v-btn
                            icon
                            :href="block.InstructionUrl"
                            :disabled="!block.InstructionUrl"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <v-icon>mdi-file-document-outline</v-icon>
                        </v-btn>
                    </td>
                    <td class="text-center text-no-wrap">
                        <v-btn
                            icon
                            :href="block.YouTubeUrl"
                            :disabled="!block.YouTubeUrl"
                            target="_blank"
                            rel="noopener noreferrer"
                            color="red darken-1"
                        >
                            <v-icon>mdi-youtube</v-icon>
                        </v-btn>
                    </td>
                    <td class="text-center text-no-wrap">
                        <v-btn
                            icon
                            :href="block.WPUrl"
                            :disabled="!block.WPUrl"
                            target="_blank"
                            rel="noopener noreferrer"
                            color="deep-purple lighten-2"
                        >
                            <icon-woocommerce />
                        </v-btn>
                    </td>
                    <td class="text-right">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-if="block.InstructionUrl" v-bind="attrs" v-on="on" icon @click="showBlockInstructionDeleteDialog(block)">
                                    <v-icon>mdi-trash-can-outline</v-icon>
                                </v-btn>
                                <v-btn v-else v-bind="attrs" v-on="on" icon @click="showBlockInstructionStoreDialog(block)">
                                    <v-icon>mdi-plus-circle-outline</v-icon>
                                </v-btn>
                            </template>
                            <span v-if="block.InstructionUrl">Usuń instrukcję</span>
                            <span v-else>Dodaj instrukcję</span>
                        </v-tooltip>
                    </td>
                </tr>
                </tbody>
            </template>
        </v-simple-table>
        <v-alert
            v-else
            border="left"
            colored-border
            type="info"
            elevation="1"
        >{{ emptyMessage }}</v-alert>

        <v-dialog
            v-model="blockEditDialog"
            persistent
            width="1200"
        >
            <v-card v-if="blockToEdit">
                <v-card-title class="headline grey lighten-2 mb-5">
                    Edycja bryły
                    {{ blockToEdit.System.SystemName }}
                    {{ blockToEdit.BlockName }}
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="hideBlockEditDialog"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-window v-model="blockFormTab">
                    <v-window-item :value="0">
                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                    <v-row>
                                        <v-col cols="4">
                                            <v-text-field
                                                v-model="blockForm.Length"
                                                label="Długość [mm]"
                                                type="number"
                                                step="1"
                                                min="0"
                                                max="32767"
                                                :error="$store.getters.hasValidationError('Length')"
                                                :error-messages="$store.getters.validationError('Length')"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-text-field
                                                v-model="blockForm.Width"
                                                label="Szerokość [mm]"
                                                type="number"
                                                step="1"
                                                min="0"
                                                max="32767"
                                                :error="$store.getters.hasValidationError('Width')"
                                                :error-messages="$store.getters.validationError('Width')"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-text-field
                                                v-model="blockForm.Height"
                                                label="Wysokość [mm]"
                                                type="number"
                                                step="1"
                                                min="0"
                                                max="32767"
                                                :error="$store.getters.hasValidationError('Height')"
                                                :error-messages="$store.getters.validationError('Height')"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-text-field
                                        v-model="blockForm.YouTubeUrl"
                                        label="Adres YouTube"
                                        :error="$store.getters.hasValidationError('YouTubeUrl')"
                                        :error-messages="$store.getters.validationError('YouTubeUrl')"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-window-item>

                    <v-window-item :value="1">
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="blockForm.CommercialName"
                                        label="Nazwa"
                                        :error="$store.getters.hasValidationError('CommercialName')"
                                        :error-messages="$store.getters.validationError('CommercialName')"
                                    ></v-text-field>
                                    <v-text-field
                                        v-model="blockForm.WPUrl"
                                        label="Adres WWW produktu"
                                        :error="$store.getters.hasValidationError('WPUrl')"
                                        :error-messages="$store.getters.validationError('WPUrl')"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <wysiwyg v-model="blockForm.CommercialDescription" placeholder="Opis" style="height: 100%" />
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-window-item>

                    <v-window-item :value="2">
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="blockForm.CommercialNameEng"
                                        label="Nazwa"
                                        :error="$store.getters.hasValidationError('CommercialNameEng')"
                                        :error-messages="$store.getters.validationError('CommercialNameEng')"
                                    ></v-text-field>
                                    <v-text-field
                                        v-model="blockForm.WPUrlEng"
                                        label="Adres WWW produktu"
                                        :error="$store.getters.hasValidationError('WPUrlEng')"
                                        :error-messages="$store.getters.validationError('WPUrlEng')"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <wysiwyg v-model="blockForm.CommercialDescriptionEng" placeholder="Opis" style="height: 100%" />
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-window-item>
                </v-window>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-btn-toggle
                        v-model="blockFormTab"
                        mandatory
                        borderless
                        dense
                    >
                        <v-btn>
                            <v-icon>mdi-set-center</v-icon>
                        </v-btn>
                        <v-btn>
                            <country-flag
                                country="pl"
                                style="
                                    width: 40px;
                                    border-radius: 20%;
                                    background-position-x: -10px;
                                "
                            />
                        </v-btn>
                        <v-btn>
                            <country-flag
                                country="gb"
                                style="
                                    width: 40px;
                                    border-radius: 20%;
                                    background-position-x: -10px;
                                "
                            />
                        </v-btn>
                    </v-btn-toggle>
                    
                    <v-spacer></v-spacer>
                    <v-btn
                        rounded
                        color="success"
                        @click="blockUpdate"
                        :loading="blockUpdating"
                    >Zapisz</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="blockInstructionStoreDialog"
            persistent
            width="500"
        >
            <v-card v-if="blockToStoreBlockInstruction">
                <v-card-title class="headline grey lighten-2 mb-5">
                    Instrukcja bryły {{ blockToStoreBlockInstruction.System.SystemName }}
                    {{ blockToStoreBlockInstruction.BlockName }}
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="hideBlockInstructionStoreDialog"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-file-input
                        v-model="blockInstructionForm.BlockInstruction"
                        label="Instrukcja bryły"
                        hint="Dozwolone formaty: pdf. Maksymalny rozmiar: 5Mb."
                        accept=".pdf"
                        persistent-hint
                        prepend-icon="mdi-file-document-outline"
                        :error="$store.getters.hasValidationError('BlockInstruction')"
                        :error-messages="$store.getters.validationError('BlockInstruction')"
                    ></v-file-input>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        rounded
                        color="success"
                        @click="blockInstructionStore"
                        :loading="blockInstructionStoring"
                    >Dodaj</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="blockInstructionDeleteDialog"
            persistent
            width="500"
        >
            <v-card v-if="blockToDeleteBlockInstruction">
                <v-card-title class="headline grey lighten-2 mb-5">
                    Usuwanie instrukcji
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="hideBlockInstructionDeleteDialog"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    Czy na pewno chcesz usunąć instrukcję bryły
                    <strong>
                        {{ blockToDeleteBlockInstruction.System.SystemName }}
                        {{ blockToDeleteBlockInstruction.BlockName }}
                    </strong>
                    ?
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        rounded
                        @click="blockInstructionDelete(blockToDeleteBlockInstruction)"
                        :loading="blockInstructionDeleting"
                    >Usuń</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import CountryFlag from 'vue-country-flag'
import LoadingMessage from "../../../components/LoadingMessage";
import BlockVisibilitySwitch from "../../../components/BlockVisibilitySwitch.vue";
import IconWoocommerce from "../../../components/IconWoocommerce";

export default {
    name: "Blocks",
    components: {
        CountryFlag,
        BlockVisibilitySwitch,
        LoadingMessage,
        IconWoocommerce
    },
    data() {
        return {
            searchQuery: "",

            blockIndexing: false,
            blocks: [],

            blockEditDialog: false,
            blockToEdit: null,
            blockUpdating: false,

            blockInstructionStoreDialog: false,
            blockToStoreBlockInstruction: null,
            blockInstructionStoring: false,

            blockInstructionDeleteDialog: false,
            blockToDeleteBlockInstruction: null,
            blockInstructionDeleting: false,

            blockFormTab: 0,

            blockForm: {
                CommercialName: null,
                Length: null,
                Width: null,
                Height: null,
                YouTubeUrl: null,
                WPUrl: null,
                CommercialDescription: null,

                CommercialNameEng: null,
                CommercialDescriptionEng: null,
                WPUrlEng: null
            },

            blockInstructionForm: {
                BlockInstruction: null,
            },

            systems: [],
            systemIndexing:false,
            systemId: null,

            // pagination
            page: 1,
            lastPage:1,
            from: 0,
            to: 0,
            total: 0,
        };
    },
    computed: {
        isMobile() {
            return this.$vuetify.breakpoint.mobile;
        },

        isPageFirst() {
            return this.page === 1;
        },

        isPageLast() {
            return this.page === this.lastPage;
        },

        loadingMessage() {
            return !this.searchQuery
                ? "Pobieranie listy brył..."
                : "Wyszukiwanie brył...";
        },

        emptyMessage() {
            return !this.searchQuery
                ? "Brak brył"
                : "Nie znaleziono brył pasujących do podanej frazy";
        },

        tableHeight() {
            return `calc(100vh - 76px - ${this.$vuetify.breakpoint.mdAndUp ? 72 : 142}px - ${this.$store.state.footerHeight}px)`;
        }
    },
    methods: {
        loadPage() {
            //If any request_search is currently in progress, cancel it!
            if (this.$store.state.sources.load_blocks) {
                this.$store.state.sources.load_blocks.cancel();
            }

            //Run debouncedFetch
            this.debouncedBlockIndexFast();
        },
        nextPage: function () {
            if (this.page < this.lastPage) {
                this.page++;
                this.loadPage();
            }
        },
        prevPage: function () {
            if (this.page > 1) {
                this.page--;
                this.loadPage();
            }
        },
        resetPage () {
            this.page = 1;
        },
        blockIndex () {
            this.blockIndexing = true;

            this.$store.dispatch('blockIndex', {
                page: this.page,
                searchQuery: this.searchQuery,
                systemId: this.systemId,
            }).then(response => {
                if(response.status === 200) {
                    this.blocks = response.data.data;
                    this.page = response.data.meta.current_page ?? 1;
                    this.lastPage = response.data.meta.last_page ?? 1;
                    this.from = response.data.meta.from ?? 0;
                    this.to = response.data.meta.to ?? 0;
                    this.total = response.data.meta.total;
                } else {
                    this.$store.commit("showSnackbarError", "Błąd ładowania listy brył.");
                }
            })
                .catch(() => {})
                .then(() => {
                    this.blockIndexing = false;
                });
        },
        blockUpdate: function () {
            this.blockUpdating = true;

            this.$store.dispatch('blockUpdate', {
                BlockID: this.blockToEdit.BlockID,
                formData: this.blockForm
            }).then(response => {
                if ([200, 201].includes(response.status)) {
                    this.hideBlockEditDialog();
                    this.$store.commit("showSnackbarSuccess", "Zapisano zmiany w bryle.");
                    this.blockIndex();
                } else {
                    this.$store.commit("showSnackbarError", "Błąd zapisu bryły.");
                }
            })
                .catch(error => {})
                .then(() => {
                    this.blockUpdating = false;
                });
        },
        blockInstructionStore: function () {
            this.blockInstructionStoring = true;

            this.$store.dispatch('blockInstructionStore', {
                BlockID: this.blockToStoreBlockInstruction.BlockID,
                formData: this.blockInstructionForm
            }).then(response => {
                if ([200, 201].includes(response.status)) {
                    this.hideBlockInstructionStoreDialog();
                    this.$store.commit("showSnackbarSuccess", "Zapisano instrukcję.");
                    this.blockIndex();
                } else {
                    this.$store.commit("showSnackbarError", "Błąd zapisu instrukcji.");
                }
            })
                .catch(() => {})
                .then(() => {
                    this.blockInstructionStoring = false;
                });
        },
        blockInstructionDelete: function (block) {
            this.blockInstructionDeleting = true;

            this.$store.dispatch('blockInstructionDelete', block.BlockID).then(response => {
                if (response.status === 204) {
                    this.hideBlockInstructionDeleteDialog();
                    this.$store.commit("showSnackbarSuccess", "Usunięto instrukcję.");
                    this.blockIndex();
                } else {
                    this.$store.commit("showSnackbarError", "Błąd usuwania instrukcji.");
                }
            })
                .catch(() => {})
                .then(() => {
                    this.blockInstructionDeleting = false;
                });
        },
        systemIndex () {
            this.systemIndexing = true;

            this.$store.dispatch('loadSystems', {
                allSystems: 1,
            }).then(response => {
                if(response.status === 200) {
                    this.systems = response.data.data;
                } else {
                    this.$store.commit("showSnackbarError", "Błąd ładowania listy systemów.");
                }
            })
                .catch(() => {})
                .then(() => {
                    this.systemIndexing = false;
                });
        },
        showBlockEditDialog: function (block) {
            this.blockToEdit = block;
        },
        hideBlockEditDialog: function () {
            this.blockEditDialog = false;
        },
        showBlockInstructionStoreDialog: function (block) {
            this.blockToStoreBlockInstruction = block;
        },
        hideBlockInstructionStoreDialog: function () {
            this.blockInstructionStoreDialog = false;
        },
        showBlockInstructionDeleteDialog: function (block) {
            this.blockToDeleteBlockInstruction = block;
        },
        hideBlockInstructionDeleteDialog: function () {
            this.blockInstructionDeleteDialog = false;
        },
        resetBlockInstructionForm: function () {
            for (const index in this.blockInstructionForm) {
                this.blockInstructionForm[index] = null;
            }
        },
        resetBlockForm: function () {
            for (const index in this.blockForm) {
                this.blockForm[index] = null;
            }
        },
        setBlockForm: function (block) {
            this.blockForm.CommercialName = block.CommercialName;
            this.blockForm.Length = block.Length;
            this.blockForm.Width = block.Width;
            this.blockForm.Height = block.Height;
            this.blockForm.YouTubeUrl = block.YouTubeUrl;
            this.blockForm.WPUrl = block.WPUrl;
            this.blockForm.CommercialDescription = block.CommercialDescription;

            this.blockForm.CommercialNameEng = block.CommercialNameEng;
            this.blockForm.CommercialDescriptionEng = block.CommercialDescriptionEng;
            this.blockForm.WPUrlEng = block.WPUrlEng;
        },
    },
    created() {
        this.debouncedBlockIndex = _.debounce(this.blockIndex, 900);
        this.debouncedBlockIndexFast = _.debounce(this.blockIndex, 300);

        this.blockIndex();
        this.systemIndex();
    },
    watch: {
        searchQuery: function () {
            this.resetPage();

            //If any request_search is currently in progress, cancel it!
            if (this.$store.state.sources.load_blocks) {
                this.$store.state.sources.load_blocks.cancel();
            }

            //Run debouncedFetch
            this.debouncedBlockIndex();
        },
        systemId: function () {
            this.resetPage();

            //If any request_search is currently in progress, cancel it!
            if (this.$store.state.sources.block_index) {
                this.$store.state.sources.block_index.cancel();
            }

            //Run debouncedFetch
            this.debouncedBlockIndexFast();
        },
        blockToEdit: function (block) {
            if(block !== null) {
                this.setBlockForm(block);
                this.blockFormTab = 0;
                this.blockEditDialog = true;
            }
        },
        blockEditDialog: function (visible) {
            if(!visible) {
                this.resetBlockForm();
                this.$store.commit("resetValidation");
                this.blockToEdit = null;
            }
        },
        blockToStoreBlockInstruction: function (block) {
            if(block !== null) {
                this.blockInstructionStoreDialog = true;
            }
        },
        blockInstructionStoreDialog: function (visible) {
            if(!visible) {
                this.resetBlockInstructionForm();
                this.$store.commit("resetValidation");
                this.blockToStoreBlockInstruction = null;
            }
        },
        blockToDeleteBlockInstruction: function (block) {
            if(block !== null) {
                this.blockInstructionDeleteDialog = true;
            }
        },
        blockInstructionDeleteDialog: function (visible) {
            if(!visible) {
                this.blockToDeleteBlockInstruction = null;
            }
        },
    }
}
</script>

<style scoped>

</style>
